import type { RFQ } from '@/types/api/rfq'

import { isAfter } from 'date-fns/isAfter'

import { BodyXS } from '@/components/atomic/text'
import {
  CountdownTimer,
  RfqTimeType,
} from '@/components/molecules/countdown-timer'
import { countdownVariants } from '@/components/molecules/countdown-timer/styles'

function RfqTimer({ rfqSummary }: { rfqSummary: RFQ | null }): React.ReactNode {
  if (!rfqSummary) {
    return null
  }
  if (
    rfqSummary.due_time &&
    isAfter(new Date(rfqSummary.due_time), new Date())
  ) {
    return (
      <CountdownTimer
        timestamp={rfqSummary.due_time}
        rfqTimeType={RfqTimeType.DueTime}
        showIcon
        showLabel
      />
    )
  }
  if (
    rfqSummary.firm_until_time &&
    isAfter(new Date(rfqSummary.firm_until_time), new Date())
  ) {
    return (
      <CountdownTimer
        timestamp={rfqSummary.firm_until_time}
        rfqTimeType={RfqTimeType.FirmUntilTime}
        showIcon
        showLabel
      />
    )
  }
  if (
    rfqSummary.expire_time &&
    isAfter(new Date(rfqSummary.expire_time), new Date())
  ) {
    return (
      <CountdownTimer
        timestamp={rfqSummary.expire_time}
        rfqTimeType={RfqTimeType.ExpireTime}
        showIcon
        showLabel
      />
    )
  }
  return (
    <BodyXS className={countdownVariants({ variant: 'danger' })}>
      Expired
    </BodyXS>
  )
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default RfqTimer
